"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingClassMetadataCountReflectKey = void 0;
exports.pendingClassMetadataCountReflectKey = '@inversifyjs/core/pendingClassMetadataCountReflectKey';
//# sourceMappingURL=pendingClassMetadataCountReflectKey.js.map